"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduledReactionDowCheckDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const enums_1 = require("../../enums");
class ScheduledReactionDowCheckDto {
    constructor(scheduledReactionDowCheckOptions) {
        if (!scheduledReactionDowCheckOptions)
            return;
        this.reactionId = scheduledReactionDowCheckOptions.reactionId;
        this.daysOfWeek = scheduledReactionDowCheckOptions.daysOfWeek;
    }
    reactionId;
    daysOfWeek;
}
exports.ScheduledReactionDowCheckDto = ScheduledReactionDowCheckDto;
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], ScheduledReactionDowCheckDto.prototype, "reactionId", void 0);
__decorate([
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsEnum)(enums_1.DaysOfWeekEnum, { each: true }),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], ScheduledReactionDowCheckDto.prototype, "daysOfWeek", void 0);
